import { SaleReference } from './SaleStore';
import {
  getRoot,
  IAnyModelType,
  Instance,
  SnapshotIn,
  SnapshotOut,
  types,
} from 'mobx-state-tree';
import {
  SupplierItemReference,
  ProductReference,
} from './products/ProductStore';
import { RootModelType } from './Root';
import { modelWithCRUD } from './utils/modelWithCRUD';
import { PurchaseOrderReference } from './PurchaseOrderStore';

export const PurchaseOrderItem = types
  .model('PurchaseOrderItem', {
    id: types.union(types.identifier, types.identifierNumber),
    purchase_order: types.maybeNull(types.late(() => PurchaseOrderReference)),
    supplier_item: types.maybeNull(types.late(() => SupplierItemReference)),
    product: types.maybeNull(types.late(() => ProductReference)),
    related_sales: types.array(types.late(() => SaleReference)),
    quantity: types.number,
    quantity_completed: types.number,
    quantity_cancelled: types.number,
    cost_price: types.number,
    cost_price_currency: types.string,
  })
  .actions((self) => ({
    setQuantity(quantity: number) {
      self.quantity = quantity;
    },
    setUnitCostPrice(costPrice: number) {
      self.cost_price = costPrice * self.quantity;
    },
    setCostPrice(costPrice: number) {
      self.cost_price = costPrice;
    },
  }));

export const PurchaseOrderItemStore = modelWithCRUD(
  'purchase-order-items',
  PurchaseOrderItem
).named('PurchaseOrderItemStore');

export const PurchaseOrderItemReference = types.reference(
  types.late((): IAnyModelType => PurchaseOrderItem),
  {
    get(identifier: string, parent): any {
      return (
        getRoot(parent!) as RootModelType
      ).purchaseOrderItemStore.getItemNaive(identifier);
    },
    set(value) {
      return value.id;
    },
  }
);

export interface IPurchaseOrderItem
  extends Instance<typeof PurchaseOrderItem> {}
export interface IPurchaseOrderItemSnapshotIn
  extends SnapshotIn<typeof PurchaseOrderItem> {}
export interface IPurchaseOrderItemSnapshotOut
  extends SnapshotOut<typeof PurchaseOrderItem> {}
